import { Grid2 as Grid, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function NoOrdersDefaultState() {
  const { t } = useTranslation(['description']);

  const title = t('orders.retrieve.no_orders', { ns: 'description' });

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Grid xs="auto">
        <CheckCircleOutlineIcon
          sx={{ fontSize: 60, color: 'action.active', mb: 2, width: '100%' }}
        />
      </Grid>
      <Grid xs="auto" my={2}>
        <Typography variant="body2" align="center">
          {title}
        </Typography>
      </Grid>
      <Grid xs="auto">
        <Typography variant="body2" align="center">
          <Trans
            i18nKey="orders.retrieve.no_orders_description"
            ns="description"
            components={[<Link to="/" style={{ fontWeight: 600 }} />]}
          />
        </Typography>
      </Grid>
    </Grid>
  );
}

export default NoOrdersDefaultState;
